import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  const items = ['item1', 'item2', 'item3', 'item4', 'item5', 'item6', 'item7'];
  const pills = ['trust.about', 'trust.editorial', 'trust.update', 'trust.safetyLink'];

  return (
    <section id="trust" className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl font-bold text-stone-900 md:text-3xl">
              {t('trust.title')}
            </h2>
            <p className="mt-3 text-sm text-stone-500 md:text-base">{t('trust.subtitle')}</p>

            <ul className="mt-6 space-y-3">
              {items.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-sm text-emerald-600">
                    <i className="ri-check-line"></i>
                  </span>
                  <span className="text-sm text-stone-700">{t(`trust.${item}`)}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-stone-200 bg-cream p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-emerald-600 text-2xl text-white">
              <i className="ri-shield-star-line"></i>
            </div>
            <h3 className="mt-5 font-heading text-lg font-semibold text-stone-900">
              {t('trust.title')}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-stone-500">{t('trust.subtitle')}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              {pills.map((pill) => (
                <span
                  key={pill}
                  className="whitespace-nowrap rounded-full border border-stone-200 bg-white px-3 py-1.5 text-xs font-medium text-stone-600"
                >
                  {t(pill)}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}